
import MainLayout from "@/components/layout/MainLayout";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Clock, Users, Star } from "lucide-react";
import { Link } from "react-router-dom";
import PageSEO from "@/components/seo/PageSEO";

const Journeys = () => {
  const journeys = [
    {
      id: "anxiety-management",
      title: "Gestão da Ansiedade",
      description: "Uma jornada completa para compreender e gerenciar a ansiedade no dia a dia.",
      duration: "4 semanas",
      sessions: 12,
      difficulty: "Iniciante",
      rating: 4.8,
      participants: 1250,
      tags: ["Ansiedade", "Mindfulness", "Respiração"]
    },
    {
      id: "emotional-intelligence",
      title: "Inteligência Emocional",
      description: "Desenvolva sua capacidade de reconhecer, compreender e gerenciar emoções.",
      duration: "6 semanas", 
      sessions: 18,
      difficulty: "Intermediário",
      rating: 4.9,
      participants: 890,
      tags: ["Emoções", "Relacionamentos", "Autoconhecimento"]
    }
  ];

  const breadcrumbs = [
    {
      position: 1,
      name: "Início",
      item: "https://metrocalma.org/app"
    },
    {
      position: 2,
      name: "Jornadas",
      item: "https://metrocalma.org/jornadas"
    }
  ];

  const structuredData = {
    "@type": "Course",
    "name": "Jornadas de Bem-estar metrocalma",
    "description": "Programas estruturados de bem-estar mental com sessões guiadas para crescimento pessoal e desenvolvimento emocional.",
    "provider": {
      "@type": "Organization",
      "name": "metrocalma"
    },
    "educationalLevel": "All Levels",
    "courseMode": "online",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.85",
      "reviewCount": "2140"
    }
  };

  return (
    <MainLayout>
      <PageSEO 
        title="Jornadas de Bem-estar - metrocalma | Programas Guiados de Crescimento Pessoal"
        description="Participe de jornadas estruturadas de bem-estar mental. Programas completos com sessões guiadas para ansiedade, inteligência emocional e crescimento pessoal."
        canonicalUrl="https://metrocalma.org/jornadas"
        keywords="jornadas bem-estar, programas crescimento pessoal, gestão ansiedade, inteligência emocional, desenvolvimento pessoal"
        pageName="Jornadas"
        pageType="Course"
        structuredData={structuredData}
        breadcrumbs={breadcrumbs}
      />
      
      <div className="container mx-auto py-8">
        <Card>
          <CardHeader>
            <CardTitle>Jornadas de Bem-estar</CardTitle>
            <CardDescription>
              Programas estruturados para seu crescimento pessoal e bem-estar mental.
            </CardDescription>
          </CardHeader>
          <CardContent className="grid gap-6 md:grid-cols-2">
            {journeys.map((journey) => (
              <Card key={journey.id} className="hover:shadow-lg transition-shadow">
                <CardHeader>
                  <div className="flex justify-between items-start">
                    <CardTitle className="text-lg">{journey.title}</CardTitle>
                    <Badge variant="secondary">{journey.difficulty}</Badge>
                  </div>
                  <CardDescription>{journey.description}</CardDescription>
                </CardHeader>
                <CardContent className="space-y-4">
                  <div className="flex items-center gap-4 text-sm text-muted-foreground">
                    <div className="flex items-center gap-1">
                      <Clock className="h-4 w-4" />
                      {journey.duration}
                    </div>
                    <div className="flex items-center gap-1">
                      <Users className="h-4 w-4" />
                      {journey.participants} participantes
                    </div>
                    <div className="flex items-center gap-1">
                      <Star className="h-4 w-4 fill-yellow-400 text-yellow-400" />
                      {journey.rating}
                    </div>
                  </div>
                  
                  <div className="flex flex-wrap gap-2">
                    {journey.tags.map((tag) => (
                      <Badge key={tag} variant="outline" className="text-xs">
                        {tag}
                      </Badge>
                    ))}
                  </div>
                  
                  <Button asChild className="w-full">
                    <Link to={`/jornadas/${journey.id}`}>
                      Iniciar Jornada
                    </Link>
                  </Button>
                </CardContent>
              </Card>
            ))}
          </CardContent>
        </Card>
      </div>
    </MainLayout>
  );
};

export default Journeys;
